// Case 6 of the access restrictions (ClickUp 86akmywy6): the banner a cancelled
// workspace sees on every page that shows notices. DS Banner in the danger
// tone, in place of the legacy inactive GNotice; its CTA opens the new plan
// modal in place instead of sending the user to Billing.
import { Banner } from '@clickguard/design-system'
import { NewSubscriptionPlan } from 'pages/workspace/billing/subscription-tab/actions/new-subscription-plan'

export const PlanEndedBanner = () => (
	// Same outer spacing as GNotice, so the page below does not move.
	<div className="max-w-full mx-auto px-4 pt-6">
		<Banner
			tone="danger"
			title="Your plan has ended, so ClickGuard is no longer protecting your ads."
			actions={<NewSubscriptionPlan />}
		/>
	</div>
)
